import { useLoader } from '@react-three/fiber';
import { useMemo } from 'react';
import { DoubleSide, MeshPhysicalMaterial, RepeatWrapping, SRGBColorSpace, TextureLoader } from 'three';

import sheet from 'app/assets/DokaSheet.webp';
import { applyMaterialQuality } from 'app/modules/wallforming/components/scenes/objects/articles/utils/batchedMeshUtils';

/**
 * Loads and returns a physical material for the sheet mesh, applying texture and quality settings.
 */
export const useSheetMaterialLoader = () => {
    const texture = useLoader(TextureLoader, sheet);

    const material = useMemo(() => {
        if (!texture) {
            return null;
        }

        const clonedTexture = texture.clone();
        clonedTexture.wrapS = RepeatWrapping;
        clonedTexture.wrapT = RepeatWrapping;
        clonedTexture.offset.set(0.5, 0);
        clonedTexture.colorSpace = SRGBColorSpace;

        const physicalMaterial = new MeshPhysicalMaterial({ color: '#ffffff', side: DoubleSide, map: clonedTexture });
        applyMaterialQuality(physicalMaterial, 'basic', true);
        return physicalMaterial;
    }, [texture]);

    return material;
};
